/* tslint:disable */

declare var Object: any;
export interface StorageCompanyProfileInterface {
  "id"?: number;
}

export class StorageCompanyProfile implements StorageCompanyProfileInterface {
  "id": number;
  constructor(data?: StorageCompanyProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageCompanyProfile`.
   */
  public static getModelName() {
    return "StorageCompanyProfile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageCompanyProfile for dynamic purposes.
  **/
  public static factory(data: StorageCompanyProfileInterface): StorageCompanyProfile{
    return new StorageCompanyProfile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageCompanyProfile',
      plural: 'StorageCompanyProfiles',
      path: 'StorageCompanyProfiles',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageCompanyProfile.ts